"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.cssAnchorName = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _axios = _interopRequireDefault(require("axios"));

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _message = _interopRequireDefault(require("@insided/deprecated-preact-components/design-system-components/message"));

var _index = _interopRequireWildcard(require("@insided/deprecated-preact-components/design-system-components/modal/index"));

var _Message = require("@insided/deprecated-control/ui-components/Message");

var _localStorageCache = _interopRequireDefault(require("@insided/deprecated-utils/localStorageCache"));

var _Button = _interopRequireDefault(require("@insided/deprecated-control/ui-components/Button"));

var _globals = require("@insided/shared/utils/globals");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var cssAnchorName = 'group-join';
exports.cssAnchorName = cssAnchorName;
var TOKEN_STORE = 'group_invite_token';
var PUBLIC_GROUP_TYPE = 4;

function hasGroupId(item) {
  return item instanceof Object && 'id' in item;
}

function hasToken(item) {
  return item instanceof Object && 'token' in item;
}

function isCategorySelected(event) {
  return event instanceof CustomEvent && event.detail.id;
}

function isTopicNew(event) {
  return event instanceof CustomEvent && event.detail.category;
}

var GroupJoin = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(GroupJoin, _Component);

  var _super = _createSuper(GroupJoin);

  function GroupJoin(props) {
    var _this;

    (0, _classCallCheck2.default)(this, GroupJoin);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "subscription", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "proceedWithJoining", function () {
      var _this$props$groupId;

      _localStorageCache.default.setItem(TOKEN_STORE, {
        id: (_this$props$groupId = _this.props.groupId) !== null && _this$props$groupId !== void 0 ? _this$props$groupId : GroupJoin.getGroupIdFromUrl(),
        token: _this.getToken()
      });

      _this.setState({
        closedModal: true
      });

      window.dispatchEvent(new window.CustomEvent('GuestUserAction'));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleTopicNew", function (event) {
      if (!isTopicNew(event)) return;
      if (_this.state.groupId !== event.detail.category) return;

      _localStorageCache.default.setItem(TOKEN_STORE, {
        id: _this.state.groupId
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleCategorySelected", /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(event) {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (isCategorySelected(event)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                if (!(event.detail.types[0] !== PUBLIC_GROUP_TYPE || !event.detail.id)) {
                  _context.next = 5;
                  break;
                }

                _this.setState({
                  groupId: undefined,
                  showPublicGroupMessage: undefined
                });

                return _context.abrupt("return");

              case 5:
                _context.next = 7;
                return GroupJoin.isMemberOf(event.detail.id);

              case 7:
                if (!_context.sent) {
                  _context.next = 9;
                  break;
                }

                return _context.abrupt("return");

              case 9:
                _this.setState({
                  groupId: event.detail.id,
                  showPublicGroupMessage: 'topic'
                });

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "showMessageIfNotMember", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(window.inSidedData.content.category.type !== 'group')) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt("return");

            case 2:
              _context2.next = 4;
              return GroupJoin.isMemberOf(window.inSidedData.content.category.id);

            case 4:
              if (!_context2.sent) {
                _context2.next = 6;
                break;
              }

              return _context2.abrupt("return");

            case 6:
              _this.setState({
                showPublicGroupMessage: 'reply'
              });

            case 7:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getToken", function () {
      if (_this.props.token) return _this.props.token;
      if (typeof window === 'undefined') return '';
      if (window.location.pathname.substr(0, 8) !== '/groups/' || window.inSidedData.page.name !== 'Error 403') return '';
      var token = '';
      window.location.search.substr(1).split('&').forEach(function (item) {
        var _item$split = item.split('='),
            _item$split2 = (0, _slicedToArray2.default)(_item$split, 2),
            key = _item$split2[0],
            value = _item$split2[1];

        if (key === 'invite') token = value || '';
      });
      return token;
    });
    _this.proceedWithJoining = _this.proceedWithJoining.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleCategorySelected = _this.handleCategorySelected.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleTopicNew = _this.handleTopicNew.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(GroupJoin, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.document.removeEventListener('topic:category_selected', this.handleCategorySelected);
      if (this.subscription) this.subscription();
    }
  }, {
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
        var payload, res, _res;

        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(this.props.publicGroupMessage && GroupJoin.shouldJoinPublicGroup())) {
                  _context3.next = 6;
                  break;
                }

                window.document.addEventListener('topic:submit', this.handleTopicNew);
                window.document.addEventListener('topic:category_selected', this.handleCategorySelected);
                this.subscription = (0, _globals.subscribe)('post_editor_submit', GroupJoin.handleEditorSubmit);
                _context3.next = 6;
                return this.showMessageIfNotMember();

              case 6:
                if (GroupJoin.isUserLoggedIn()) {
                  _context3.next = 8;
                  break;
                }

                return _context3.abrupt("return");

              case 8:
                if (GroupJoin.isValidRole()) {
                  _context3.next = 10;
                  break;
                }

                return _context3.abrupt("return");

              case 10:
                payload = _localStorageCache.default.getItemAndRemove(TOKEN_STORE);

                if (!hasToken(payload)) {
                  _context3.next = 17;
                  break;
                }

                _context3.next = 14;
                return _axios.default.post('/groups/joinWithToken', payload);

              case 14:
                res = _context3.sent;
                this.setState({
                  groupTitleAfterJoin: res.data.group.title
                });
                return _context3.abrupt("return");

              case 17:
                if (!hasGroupId(payload)) {
                  _context3.next = 22;
                  break;
                }

                _context3.next = 20;
                return _axios.default.post("/group/".concat(payload.id, "/join"), payload);

              case 20:
                _res = _context3.sent;
                this.setState({
                  groupTitleAfterJoin: _res.data.group.title
                });

              case 22:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      if (this.state.groupTitleAfterJoin) {
        return (0, _preact.h)(_message.default, {
          variant: "success",
          onDismiss: function onDismiss() {
            return _this2.setState({
              groupTitleAfterJoin: undefined
            });
          },
          timer: 5000
        }, (0, _preact.h)(_phrase.default, {
          p: "groups.invite.joined",
          count: {
            g: this.state.groupTitleAfterJoin
          }
        }));
      }

      if (this.props.publicGroupMessage && this.state.showPublicGroupMessage) {
        return (0, _preact.h)(_Message.Message, {
          fullWidth: true
        }, (0, _preact.h)("div", {
          className: "panel-form-text"
        }, (0, _preact.h)(_phrase.default, {
          p: "group.autojoin.info.".concat(this.state.showPublicGroupMessage)
        })));
      }

      if (this.getToken() && !this.state.closedModal) {
        var _this$props$groupTitl;

        if (GroupJoin.isTokenAlreadyStored() && GroupJoin.isUserLoggedIn() && !GroupJoin.isValidRole()) {
          return (0, _preact.h)(_message.default, {
            variant: "error",
            timer: 5000,
            onDismiss: function onDismiss() {
              return _this2.setState({
                closedModal: true
              });
            }
          }, (0, _preact.h)(_phrase.default, {
            p: "groups.invite.invalid_role"
          }));
        }

        return (0, _preact.h)(_index.default, {
          onClose: function onClose() {
            return _this2.setState({
              closedModal: true
            });
          }
        }, (0, _preact.h)(_index.ModalHeader, {
          title: (0, _preact.h)(_phrase.default, {
            p: "groups.invite.modal_title",
            count: {
              g: (_this$props$groupTitl = this.props.groupTitle) !== null && _this$props$groupTitl !== void 0 ? _this$props$groupTitl : 'a group'
            }
          })
        }), (0, _preact.h)(_index.ModalBody, null, (0, _preact.h)(_phrase.default, {
          p: "groups.invite.modal_body"
        })), (0, _preact.h)(_index.ModalFooter, null, (0, _preact.h)(_Button.default, {
          onClick: function onClick() {
            return _this2.proceedWithJoining();
          }
        }, (0, _preact.h)(_phrase.default, {
          p: "groups.invite.modal_confirm"
        }))));
      }

      return null;
    }
  }]);
  return GroupJoin;
}(_preact.Component);

exports.default = GroupJoin;
(0, _defineProperty2.default)(GroupJoin, "isUserLoggedIn", function () {
  return !!window.inSidedData.user.userid;
});
(0, _defineProperty2.default)(GroupJoin, "isValidRole", function () {
  return window.inSidedData.user.mainRole !== 'roles.not-activated' && window.inSidedData.user.mainRole !== 'roles.requires-approval';
});
(0, _defineProperty2.default)(GroupJoin, "shouldJoinPublicGroup", function () {
  return ['roles.super-user', 'roles.registered'].includes(window.inSidedData.user.mainRole);
});
(0, _defineProperty2.default)(GroupJoin, "isMemberOf", /*#__PURE__*/function () {
  var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(groupId) {
    var res;
    return _regenerator.default.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            if (!(groupId <= 0)) {
              _context4.next = 2;
              break;
            }

            return _context4.abrupt("return", false);

          case 2:
            _context4.next = 4;
            return _axios.default.get("/group/".concat(groupId, "/isMember"));

          case 4:
            res = _context4.sent;
            return _context4.abrupt("return", !!res.data);

          case 6:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function (_x2) {
    return _ref3.apply(this, arguments);
  };
}());
(0, _defineProperty2.default)(GroupJoin, "handleEditorSubmit", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5() {
  return _regenerator.default.wrap(function _callee5$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          if (!(window.inSidedData.content.category.type !== 'group')) {
            _context5.next = 2;
            break;
          }

          return _context5.abrupt("return");

        case 2:
          _context5.next = 4;
          return GroupJoin.isMemberOf(window.inSidedData.content.category.id);

        case 4:
          if (!_context5.sent) {
            _context5.next = 6;
            break;
          }

          return _context5.abrupt("return");

        case 6:
          _localStorageCache.default.setItem(TOKEN_STORE, {
            id: window.inSidedData.content.category.id
          });

        case 7:
        case "end":
          return _context5.stop();
      }
    }
  }, _callee5);
})));
(0, _defineProperty2.default)(GroupJoin, "getGroupIdFromUrl", function () {
  var _window$location$path;

  if (window.location.pathname.substr(0, 8) !== '/groups/') return 0;
  return parseInt((_window$location$path = window.location.pathname.split('/').pop()) !== null && _window$location$path !== void 0 ? _window$location$path : '0');
});
(0, _defineProperty2.default)(GroupJoin, "isTokenAlreadyStored", function () {
  var payload = _localStorageCache.default.getItem(TOKEN_STORE);

  return hasToken(payload);
});